import { Prismic } from '@landsbankinn/prismic';
import { useMedia } from '@landsbankinn/ui';
import React from 'react';
import { Img } from '../components/img/Img';
import { AnnualHero } from '../components/slices/AnnualHero';

interface IProps {
  title: Prismic.RichText;
  image: Prismic.Image;
  shade_opacity: number;
}

export const AnnualHeroContainer = ({
  title,
  image,
  shade_opacity,
}: IProps) => {
  const isMobile = useMedia('sm');
  return (
    <AnnualHero
      title={Prismic.text(title) ?? undefined}
      image={
        <Img src={image} ar={isMobile ? 'ar_9_16' : 'ar_16_9'} percentage={1} />
      }
      shadeOpacity={shade_opacity}
    />
  );
};
